module.exports = __webpack_public_path__ + "static/media/ch-logo.f9378159.svg";